import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "refetch"],
  _excluded2 = ["data", "refetch"];
const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery as useDFCQuery } from 'data-fetching-client';
import { useResource, skipToken } from 'pulse/react';
import listingLibPerformanceTracking, { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { makeQuickFetchRequest } from 'framework-listing-lib/utils/quickFetch';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import { CRM_OBJECT_FRAGMENT } from 'framework-listing-lib/internal/graphql/fragments';
import useHasGraphQLCrmSearch from 'framework-listing-lib/internal/graphql/hooks/useHasGraphQLCrmSearch';
import useHasPulseCrmSearch from 'framework-listing-lib/internal/hooks/useHasPulseCrmSearch';
import { CrmSearchAllProperties, getPulseArgs, transformPulseResponseToCrmSearchResponse } from 'framework-listing-lib/internal/resources/pulseCrmSearch';
import { transformGraphQLResponseIntoCrmSearchResponse, getGraphQLVariables } from 'framework-listing-lib/internal/graphql/utils/graphql';
export const LISTING_LIB_CRM_SEARCH_QUERY = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"ListingLibCrmSearchQuery\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"FilterGroup\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}},\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Sort\"}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"associationSpecs\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociationSpec\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"hasAssociationSpecs\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Boolean\"}}},\"defaultValue\":{\"kind\":\"BooleanValue\",\"value\":false}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneSource\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneSource\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneSource\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasMore\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"results\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"CrmObjectFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"total\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ListingLibCrmSearchQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "count"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "offset"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "query"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "sorts"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "Sort"
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "associationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssociationSpec"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "hasAssociationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      },
      defaultValue: {
        kind: "BooleanValue",
        value: false
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "timeZoneId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "timeZoneSource"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "count"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "filterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "query"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "query"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "timeZoneId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "timeZoneId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "timeZoneSource"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "timeZoneSource"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasMore"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "offset"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "results"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CrmObjectFragment"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "total"
            }
          }]
        }
      }]
    }
  }].concat(CRM_OBJECT_FRAGMENT.definitions))
});
export const CRM_OBJECT_TYPE_FIELD_NAME = 'crmObjectType';
export const CRM_OBJECT_TYPE_QUERY = registerQuery({
  fieldName: CRM_OBJECT_TYPE_FIELD_NAME,
  args: ['fetcher', 'fetchParams', 'quickFetchName', 'removeAfterFetch'],
  fetcher({
    fetcher,
    fetchParams,
    quickFetchName,
    removeAfterFetch
  }) {
    const quickFetchArg = quickFetchName || `fetch-crm-objects-${fetchParams.objectTypeId}`;
    const crmSearchRequest = () => fetcher ? fetcher(fetchParams) : http.post('/crm-search/search', {
      data: fetchParams
    });
    let performanceTracking;
    if (quickFetchArg === `fetch-crm-objects-${fetchParams.objectTypeId}`) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    return makeQuickFetchRequest({
      makeRequestFn: crmSearchRequest,
      requestName: quickFetchArg,
      removeAfterFetch
    }).then(response => {
      Metrics.counter('crm-search-success', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      if (performanceTracking) {
        performanceTracking.markTimeEnd();
      }
      return response;
    }).catch(error => {
      Metrics.counter('crm-search-failure', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      throw error;
    });
  }
});
function useTrackPerfEnd(variables, enabled) {
  "use memo";

  const $ = _c(4);
  const initialQuickFetch = `fetch-crm-objects-${variables.fetchParams.objectTypeId}`;
  const quickFetchArg = variables.quickFetchName || initialQuickFetch;
  const shouldTrack = enabled && quickFetchArg === initialQuickFetch;
  let performanceTracking;
  if ($[0] !== shouldTrack) {
    if (shouldTrack) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    $[0] = shouldTrack;
    $[1] = performanceTracking;
  } else {
    performanceTracking = $[1];
  }
  let t0;
  if ($[2] !== performanceTracking) {
    t0 = () => {
      if (performanceTracking) {
        performanceTracking.markTimeEnd();
      }
    };
    $[2] = performanceTracking;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  performanceTracking;
  return t0;
}
function usePreviousDefined(value) {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== value) {
    t0 = {
      latest: value
    };
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [tracked, setTracked] = useState(t0);
  if (value !== undefined && value !== tracked.latest) {
    setTracked({
      latest: value,
      previous: tracked.latest
    });
  }
  return tracked.previous;
}
export default function useFetchFromCRM(variables, options) {
  "use memo";

  const $ = _c(66);
  const hasGraphQLCrmSearch = useHasGraphQLCrmSearch();
  const hasPulseCrmSearch = useHasPulseCrmSearch();
  let t0;
  if ($[0] !== options) {
    t0 = options || {};
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = Object.assign({}, t0);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const incomingOptions = t1;
  let t2;
  bb0: {
    if (hasGraphQLCrmSearch || hasPulseCrmSearch) {
      let t3;
      if ($[4] !== incomingOptions) {
        t3 = Object.assign({}, incomingOptions, {
          skip: true
        });
        $[4] = incomingOptions;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = t3;
      break bb0;
    }
    t2 = incomingOptions;
  }
  const restOptions = t2;
  let t3;
  bb1: {
    if (!hasPulseCrmSearch && hasGraphQLCrmSearch) {
      t3 = incomingOptions;
      break bb1;
    }
    let t4;
    if ($[6] !== incomingOptions) {
      t4 = Object.assign({}, incomingOptions, {
        skip: true
      });
      $[6] = incomingOptions;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = t4;
  }
  const graphQLOptions = t3;
  let t4;
  if ($[8] !== restOptions || $[9] !== variables) {
    t4 = Object.assign({
      variables
    }, restOptions);
    $[8] = restOptions;
    $[9] = variables;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = useDFCQuery(CRM_OBJECT_TYPE_QUERY, t4);
  let data;
  let refetchDFC;
  let rest;
  if ($[11] !== t5) {
    var _t = t5;
    ({
      data,
      refetch: refetchDFC
    } = _t);
    rest = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[11] = t5;
    $[12] = data;
    $[13] = refetchDFC;
    $[14] = rest;
  } else {
    data = $[12];
    refetchDFC = $[13];
    rest = $[14];
  }
  const trackPerfEnd = useTrackPerfEnd(variables, hasGraphQLCrmSearch && !hasPulseCrmSearch);
  let t6;
  if ($[15] !== variables) {
    t6 = getGraphQLVariables(variables);
    $[15] = variables;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== trackPerfEnd || $[18] !== variables) {
    t7 = () => {
      Metrics.counter("crm-search-graphql-success", {
        object_type_id: variables.fetchParams.objectTypeId
      }).increment();
      trackPerfEnd();
    };
    $[17] = trackPerfEnd;
    $[18] = variables;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== variables) {
    t8 = () => {
      Metrics.counter("crm-search-graphql-failure", {
        object_type_id: variables.fetchParams.objectTypeId
      }).increment();
    };
    $[20] = variables;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== graphQLOptions || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = Object.assign({
      variables: t6,
      errorPolicy: "all",
      returnPartialData: true
    }, graphQLOptions, {
      onCompleted: t7,
      onError: t8
    });
    $[22] = graphQLOptions;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = useQuery(LISTING_LIB_CRM_SEARCH_QUERY, t9);
  let graphQLData;
  let refetchGraphQL;
  let restGraphQL;
  if ($[27] !== t10) {
    var _t2 = t10;
    ({
      data: graphQLData,
      refetch: refetchGraphQL
    } = _t2);
    restGraphQL = _objectWithoutPropertiesLoose(_t2, _excluded2);
    _t2;
    $[27] = t10;
    $[28] = graphQLData;
    $[29] = refetchGraphQL;
    $[30] = restGraphQL;
  } else {
    graphQLData = $[28];
    refetchGraphQL = $[29];
    restGraphQL = $[30];
  }
  let t11;
  if ($[31] !== variables) {
    t11 = getPulseArgs(variables);
    $[31] = variables;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const pulseArgs = t11;
  const isPulseActive = hasPulseCrmSearch && !incomingOptions.skip;
  const isPassive = incomingOptions.fetchPolicy === "cache-only";
  const t12 = isPulseActive ? pulseArgs : skipToken;
  let t13;
  if ($[33] !== incomingOptions.pollInterval || $[34] !== isPassive || $[35] !== t12) {
    t13 = {
      params: t12,
      pollInterval: incomingOptions.pollInterval,
      passive: isPassive
    };
    $[33] = incomingOptions.pollInterval;
    $[34] = isPassive;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const {
    data: pulseData,
    loading: pulseLoading,
    error: pulseError,
    stale: pulseStale
  } = useResource(CrmSearchAllProperties, t13);
  let t14;
  if ($[37] !== pulseData) {
    t14 = transformPulseResponseToCrmSearchResponse(pulseData);
    $[37] = pulseData;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  const pulseCrmSearchResponse = t14;
  const previousPulseCrmSearchResponse = usePreviousDefined(pulseCrmSearchResponse);
  let t15;
  if ($[39] !== previousPulseCrmSearchResponse) {
    t15 = previousPulseCrmSearchResponse ? {
      [CRM_OBJECT_TYPE_FIELD_NAME]: previousPulseCrmSearchResponse
    } : undefined;
    $[39] = previousPulseCrmSearchResponse;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  const pulsePreviousData = t15;
  let t16;
  if ($[41] !== hasGraphQLCrmSearch || $[42] !== hasPulseCrmSearch || $[43] !== refetchDFC || $[44] !== refetchGraphQL || $[45] !== variables) {
    t16 = refetchVariables => {
      const finalQueryVariables = refetchVariables || variables;
      if (hasPulseCrmSearch) {
        return CrmSearchAllProperties.refetch(getPulseArgs(finalQueryVariables));
      }
      if (hasGraphQLCrmSearch) {
        return refetchGraphQL(getGraphQLVariables(finalQueryVariables));
      }
      return refetchDFC(finalQueryVariables);
    };
    $[41] = hasGraphQLCrmSearch;
    $[42] = hasPulseCrmSearch;
    $[43] = refetchDFC;
    $[44] = refetchGraphQL;
    $[45] = variables;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  const refetch = t16;
  if (hasPulseCrmSearch) {
    const t17 = pulseError !== null && pulseError !== void 0 ? pulseError : undefined;
    let t18;
    if ($[47] !== pulseCrmSearchResponse || $[48] !== pulseLoading || $[49] !== pulsePreviousData || $[50] !== pulseStale || $[51] !== refetch || $[52] !== t17 || $[53] !== variables) {
      t18 = {
        data: pulseCrmSearchResponse,
        loading: pulseLoading,
        error: t17,
        stale: pulseStale,
        client: undefined,
        variables,
        previousData: pulsePreviousData,
        refetch,
        startPolling: _temp,
        stopPolling: _temp2
      };
      $[47] = pulseCrmSearchResponse;
      $[48] = pulseLoading;
      $[49] = pulsePreviousData;
      $[50] = pulseStale;
      $[51] = refetch;
      $[52] = t17;
      $[53] = variables;
      $[54] = t18;
    } else {
      t18 = $[54];
    }
    return t18;
  }
  if (hasGraphQLCrmSearch) {
    let t17;
    if ($[55] !== graphQLData || $[56] !== variables.fetchParams.objectTypeId) {
      t17 = transformGraphQLResponseIntoCrmSearchResponse(graphQLData, variables.fetchParams.objectTypeId);
      $[55] = graphQLData;
      $[56] = variables.fetchParams.objectTypeId;
      $[57] = t17;
    } else {
      t17 = $[57];
    }
    let t18;
    if ($[58] !== refetch || $[59] !== restGraphQL || $[60] !== t17) {
      t18 = Object.assign({
        data: t17,
        refetch
      }, restGraphQL);
      $[58] = refetch;
      $[59] = restGraphQL;
      $[60] = t17;
      $[61] = t18;
    } else {
      t18 = $[61];
    }
    return t18;
  }
  const t17 = data && CRM_OBJECT_TYPE_FIELD_NAME in data ? data[CRM_OBJECT_TYPE_FIELD_NAME] : undefined;
  let t18;
  if ($[62] !== refetch || $[63] !== rest || $[64] !== t17) {
    t18 = Object.assign({
      data: t17,
      refetch
    }, rest);
    $[62] = refetch;
    $[63] = rest;
    $[64] = t17;
    $[65] = t18;
  } else {
    t18 = $[65];
  }
  return t18;
}
function _temp2() {}
function _temp() {}